import React from "react";
import { PerformanceLevelView } from "../../types";
import { bandBoundaries } from "./reportCardModel";

interface Props {
  /** Null when this kind's criteria do not share a band scheme; nothing is ruled. */
  bands: PerformanceLevelView[] | null;
}

/**
 * The continuous vertical rules that run the height of a kind's criteria, over
 * the gauge lane only, so every mark is read against the same thresholds the
 * axis above prints.
 */
const BandRules: React.FC<Props> = ({ bands }) => {
  if (!bands || bands.length === 0) return null;
  const boundaries = bandBoundaries(bands);
  if (!boundaries.length) return null;

  return (
    <div className="bands" aria-hidden="true">
      {boundaries.map((position, i) => (
        <i
          key={i}
          style={{ left: `${position}%`, animationDelay: `${(i + 1) * 60}ms` }}
        />
      ))}
    </div>
  );
};

export default BandRules;
